import UpdaterIpcRouter, { CheckForUpdateOptions, UpdaterIpcRouterType } from '@shared/ipc/routers/UpdaterIpc.router.ts'

class UpdaterIpcRenderer extends UpdaterIpcRouter implements UpdaterIpcRouterType {
  async checkForUpdates(options: CheckForUpdateOptions) {
    return this.exec('checkForUpdates', options)
  }

  async downloadUpdate() {
    return this.exec('downloadUpdate')
  }

  async quitAndInstall() {
    return this.exec('quitAndInstall')
  }
}

export default new UpdaterIpcRenderer()
